import React from "react";
import Form from "./Form";
import './Login.css'

function Login() {
  return (
    <>
      <Form />
    </>
  );
}

export default Login;
